import ageStrictService from './ageStrictService';

export * from './types';
export default ageStrictService;



// WEBPACK FOOTER //
// ./src/services/agestrict/index.ts